import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Role } from './types/role.type';

/**
 * Fetches the list of roles, both Datastream-scoped and global. The API returns both scopes —
 * clients renders what is returned without filtering (umbrella spec §Roles & Permissions
 * scoping).
 *
 * @param instance - Ky HTTP instance from the application store.
 * @returns OperationResultWithData wrapping `Role[]`.
 */
export const getRoles = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<Role[]>>(Uri.roles.base).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
